export default function ({ redirect, app }) {
  if (!app.$auth.isAuthenticated) {
    return redirect(app.localePath('login'))
  }
  return Promise.resolve()
}
